import {
  Avatar,
  AvatarImage,
  AvatarFallback,
} from "../../../../components/UI/Avatar";
import { Clock, Store } from "lucide-react";
import { cn } from "../../../../utils/utils";

const STATUS_STYLE = {
  sent: { label: "Đã gửi", className: "bg-blue-50 text-blue-700" },
  received: { label: "Chờ xử lý", className: "bg-amber-50 text-amber-700" },
  accepted: { label: "Đã chấp nhận", className: "bg-emerald-50 text-emerald-700" },
  removed: { label: "Đã huỷ", className: "bg-gray-100 text-gray-600" },
  pending: { label: "Chờ xác nhận", className: "bg-amber-50 text-amber-700" },
  rejected: { label: "Đã từ chối", className: "bg-rose-50 text-rose-700" },
  expired: { label: "Hết hạn", className: "bg-gray-100 text-gray-500" },
};

const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    return d.toLocaleString("vi-VN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (e) {
    return "—";
  }
};

/**
 * Card mô tả 1 lời mời — dùng cho Sent / Received / GroupInvitations.
 */
const InvitationCard = ({
  avatar,
  title,
  subtitle,
  phone,
  createdAt,
  status,
  shopName,
  staffName,
  actions,
}) => {
  const statusConf = STATUS_STYLE[status] || STATUS_STYLE.pending;

  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm hover:shadow-md transition-shadow p-4 flex flex-col gap-3">
      <div className="flex items-start gap-3">
        <Avatar className="h-11 w-11 shrink-0">
          <AvatarImage src={avatar} alt={title} />
          <AvatarFallback>{title?.charAt(0) || "?"}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-gray-900 truncate">
            {title || "(Không tên)"}
          </div>
          {subtitle && (
            <div className="text-[12px] text-gray-500 truncate">{subtitle}</div>
          )}
          {phone && (
            <div className="text-[12px] text-gray-600 mt-0.5">{phone}</div>
          )}
        </div>
        <span
          className={cn(
            "text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap",
            statusConf.className,
          )}
        >
          {statusConf.label}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px] text-gray-500">
        {createdAt && (
          <span className="inline-flex items-center gap-1">
            <Clock size={12} />
            {formatDateTime(createdAt)}
          </span>
        )}
        {shopName && (
          <span className="inline-flex items-center gap-1">
            <Store size={12} />
            <span className="truncate max-w-[140px]">{shopName}</span>
          </span>
        )}
        {staffName && (
          <span className="inline-flex items-center gap-1">
            NV: <span className="text-gray-700">{staffName}</span>
          </span>
        )}
      </div>

      {actions && <div className="flex items-center gap-2 pt-1">{actions}</div>}
    </div>
  );
};

export default InvitationCard;
